import axiosInstance from "../services/axiosInstance";

export const ApprovalsLeaveRequest = async (payload) => {
  try {
    const response = await axiosInstance.post(
      "console/leave/approvals",
      payload,
    );

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
